var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownloadPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#49555D",
    d: "M66.2 1v510h379.5V147.8H304.5V1H66.2zm32.1 32h174.1v146.8h141.3V479H98.3V33z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#49555D",
    d: "M339 107.7h106.8L339 1v106.7z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#42B3FF",
    d: "M242 232.3h32V413h-32z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#42B3FF",
    d: "m257.3 451.1-90.1-80.4 21.3-23.9 69 61.6 70-61.7 21.2 24z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadPdf);
export default __webpack_public_path__ + "static/media/download_pdf.1ed7833ceae5d8e44b1eb5411a8f5283.svg";
export { ForwardRef as ReactComponent };